import { RootState } from 'src/redux/createRootReducer'

export const selectGetVirtualCardFailed = (state: RootState): boolean =>
  state.app.virtualCardDetail.getVirtualCardFailed
